var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdaptativeChasis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 84.3 122",
    style: {
      enableBackground: "new 0 0 84.3 122"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 84.3,
    height: 122
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82,122H62.6c-1.3,0-2.3-1-2.3-2.3v-16.5H24v16.5c0,1.3-1,2.3-2.3,2.3H2.3c-1.3,0-2.3-1-2.3-2.3V85.2 c0-1.3,1-2.3,2.3-2.3h19.4c1.3,0,2.3,1,2.3,2.3v16.5h17.4V20.3H24v16.5c0,1.3-1,2.3-2.3,2.3H2.3c-1.3,0-2.3-1-2.3-2.3V2.3 C0,1,1,0,2.3,0h19.4C23,0,24,1,24,2.3v16.5h36.3V2.3c0-1.3,1-2.3,2.3-2.3H82c1.3,0,2.3,1,2.3,2.3v34.5c0,1.3-1,2.3-2.3,2.3H62.6 c-1.3,0-2.3-1-2.3-2.3V20.3H42.9v81.5h17.4V85.2c0-1.3,1-2.3,2.3-2.3H82c1.3,0,2.3,1,2.3,2.3v34.5C84.3,120.9,83.3,122,82,122  M62.6,84.3c-0.5,0-0.9,0.4-0.9,0.9v34.5c0,0.5,0.4,0.9,0.9,0.9H82c0.5,0,0.9-0.4,0.9-0.9V85.2c0-0.5-0.4-0.9-0.9-0.9H62.6z  M2.3,84.3c-0.5,0-0.9,0.4-0.9,0.9v34.5c0,0.5,0.4,0.9,0.9,0.9h19.4c0.5,0,0.9-0.4,0.9-0.9V85.2c0-0.5-0.4-0.9-0.9-0.9H2.3z  M62.6,1.4c-0.5,0-0.9,0.4-0.9,0.9v34.5c0,0.5,0.4,0.9,0.9,0.9H82c0.5,0,0.9-0.4,0.9-0.9V2.3c0-0.5-0.4-0.9-0.9-0.9H62.6z M2.3,1.4 c-0.5,0-0.9,0.4-0.9,0.9v34.5c0,0.5,0.4,0.9,0.9,0.9h19.4c0.5,0,0.9-0.4,0.9-0.9V2.3c0-0.5-0.4-0.9-0.9-0.9H2.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdaptativeChasis);
export default __webpack_public_path__ + "static/media/Adaptative_chasis.dcf100b4c16758da1db99ae636222ea8.svg";
export { ForwardRef as ReactComponent };